import { useCookieConsent } from '@/hooks/useCookieConsent';

export default function CookieConsent() {
  const {
    state,
    acceptAll,
    acceptEssential,
    toggleAnalytics,
    closeSettings,
    settingsOpen,
  } = useCookieConsent();

  const showBanner = !state.consentGiven;

  return (
    <>
      {/* Bottom Banner */}
      {showBanner && (
        <div className="fixed bottom-0 left-0 right-0 z-[60] bg-primary-950 text-background-100 px-4 py-4 md:py-5 shadow-lg">
          <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <p className="text-sm leading-relaxed max-w-xl">
              Wir verwenden technisch notwendige Cookies für die Grundfunktion der Website.
              Details finden Sie in unserer{' '}
              <a href="/datenschutz" className="underline hover:text-background-50">
                Datenschutzerklärung
              </a>.
            </p>
            <div className="flex items-center gap-3 shrink-0">
              <button
                onClick={acceptEssential}
                className="px-4 py-2 text-sm font-medium rounded-md border border-background-600 text-background-300 hover:bg-background-900/50 transition-colors whitespace-nowrap"
              >
                Nur essenzielle
              </button>
              <button
                onClick={acceptAll}
                className="px-4 py-2 text-sm font-semibold rounded-md bg-secondary-500 text-background-50 hover:bg-secondary-600 transition-colors whitespace-nowrap"
              >
                Alle akzeptieren
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Settings Panel */}
      {settingsOpen && (
        <div
          className="fixed inset-0 z-[70] bg-black/50 flex items-center justify-center px-4"
          onClick={closeSettings}
          role="dialog"
          aria-modal="true"
          aria-labelledby="cookie-title"
        >
          <div
            className="bg-background-50 rounded-lg w-full max-w-lg p-6 md:p-8 shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="flex items-start justify-between mb-6">
              <div>
                <p className="text-[10px] font-bold tracking-[0.25em] uppercase text-foreground-400 mb-1">
                  SSG SIGNALTECHNIK
                </p>
                <h2 id="cookie-title" className="text-xl md:text-2xl font-bold text-foreground-950">
                  Cookie-Einstellungen
                </h2>
              </div>
              <button
                onClick={closeSettings}
                className="text-2xl text-foreground-400 hover:text-foreground-700 transition-colors leading-none"
                aria-label="Cookie-Einstellungen schließen"
              >
                ×
              </button>
            </div>

            <p className="text-sm text-foreground-600 leading-relaxed mb-6">
              Wir verwenden technisch notwendige Speicherungen für die grundlegende Funktion und
              Ihre Datenschutzeinstellungen. Optionale Kategorien können Sie selbst freigeben.
              Details finden Sie in unserer{' '}
              <a href="/datenschutz" className="text-primary-600 hover:underline" onClick={closeSettings}>
                Datenschutzerklärung
              </a>.
            </p>

            {/* Options */}
            <div className="space-y-4 mb-8">
              {/* Essential */}
              <div className="flex items-center justify-between py-3 border-b border-background-200">
                <div>
                  <b className="text-sm font-semibold text-foreground-900">Essenziell</b>
                  <p className="text-xs text-foreground-500 mt-0.5">
                    Grundfunktion und Speicherung Ihrer Auswahl.
                  </p>
                </div>
                <span className="text-xs font-semibold text-secondary-600 uppercase tracking-wider">
                  Immer aktiv
                </span>
              </div>

              {/* Analytics */}
              <div className="flex items-center justify-between py-3 border-b border-background-200">
                <div>
                  <b className="text-sm font-semibold text-foreground-900">Analyse &amp; Marketing</b>
                  <p className="text-xs text-foreground-500 mt-0.5">
                    Derzeit sind keine Analyse- oder Marketingdienste eingebunden.
                  </p>
                </div>
                <button
                  onClick={() => toggleAnalytics(!state.analytics)}
                  role="switch"
                  aria-checked={state.analytics}
                  aria-label="Analyse- und Marketing-Cookies umschalten"
                  className={`relative w-11 h-6 rounded-full transition-colors duration-200 ${
                    state.analytics ? 'bg-secondary-500' : 'bg-background-300'
                  }`}
                >
                  <span
                    className={`absolute top-0.5 left-0.5 w-5 h-5 bg-background-50 rounded-full shadow transition-transform duration-200 ${
                      state.analytics ? 'translate-x-5' : 'translate-x-0'
                    }`}
                  />
                </button>
              </div>
            </div>

            {/* Actions */}
            <div className="flex flex-col sm:flex-row items-center gap-3">
              <button
                onClick={acceptEssential}
                className="w-full sm:w-auto px-5 py-2.5 text-sm font-medium rounded-md border border-background-300 text-foreground-700 hover:bg-background-100 transition-colors whitespace-nowrap"
              >
                Nur essenzielle
              </button>
              <button
                onClick={() => {
                  setTimeout(() => {
                    closeSettings();
                  }, 50);
                }}
                className="w-full sm:w-auto px-5 py-2.5 text-sm font-semibold rounded-md bg-secondary-500 text-background-50 hover:bg-secondary-600 transition-colors whitespace-nowrap"
              >
                Auswahl speichern
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}